export default "__VITE_ASSET__Bx0vxVXe__"